import React from 'react';
import './Links.css';

import accommodation from '../../files/links/Accommodation_Process.pdf';
// import financial from '../../files/links/Financial Report 2017-2018.pdf';
// import financial from '../../files/links/Financial Report 2018-2019.pdf';
import { FILE } from '../../utils/constants/pdf';
import { IMAGE } from '../../utils/images/links';

const list = [
  {
    href: FILE.financialReport,
    text: 'Financial Report',
    img: [IMAGE.financial],
    color: '#1E4C7C',
  },
  {
    href: accommodation,
    text: 'Student Accommodation Request',
    img: [IMAGE.request],
    color: '#721a48',
  },
  {
    href: 'https://wwwdev.uiltexas.org/pml/',
    text: 'PML List',
    img: [IMAGE.list],
    color: '#F25A2C',
  },
  {
    href: 'https://www.texasmusicforms.com/',
    text: 'UIL Forms',
    img: [IMAGE.textBubble],
    color: '#099444',
  },
  {
    href: 'https://www.uiltexas.org/policy/notice-of-non-discrimination',
    text: 'UIL Non Discrimination Policy',
    img: [IMAGE.scroll],
    color: '#10B2AC',
  },
  {
    href: 'https://www.tmea.org/',
    text: 'TMEA Website',
    img: [IMAGE.home],
    color: '#D21526',
  },
];

const Links = () => {
  return (
    <div className="links_container">
      <div className="component_img" />
      <div className="links_body_container">
        <div>
          <h1 className="links_title">Links</h1>
        </div>
        <div className="link-list">
          {list.map((e, i) => {
            return (
              <a key={i} href={e.href} target="blank">
                <div className="link_btns">
                  <p className="links_text">{e.text}</p>
                  <div style={{ '--bubble-color': [e.color] }}>{e.img}</div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Links;



// WEBPACK FOOTER //
// ./src/Components/Links/Links.js